import { createContext, type Dispatch, type ReactNode } from "react";
import {
  reducer,
  ScheduleViewFilters,
  type ScheduleViewFiltersAction,
} from "@/pages/human-resources/time-management/components/display-filters/provider/ScheduleViewFilters.ts";
import { useImmerReducer } from "use-immer";

// eslint-disable-next-line react-refresh/only-export-components
export const ScheduleViewFiltersContext = createContext<
  ScheduleViewFilters | undefined
>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const ScheduleViewFiltersDispatchContext = createContext<
  Dispatch<ScheduleViewFiltersAction> | undefined
>(undefined);

export function ScheduleViewFiltersProvider(props: {
  children: ReactNode;
}): ReactNode {
  const [scheduleViewFilters, dispatch] = useImmerReducer(
    reducer,
    new ScheduleViewFilters(),
  );
  return (
    <ScheduleViewFiltersContext.Provider value={scheduleViewFilters}>
      <ScheduleViewFiltersDispatchContext.Provider value={dispatch}>
        {props.children}
      </ScheduleViewFiltersDispatchContext.Provider>
    </ScheduleViewFiltersContext.Provider>
  );
}
